import styled from "styled-components";
import { theme } from "@/styles/index";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  top: -200px;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  background-color: #f4f4f4;
  flex-direction: column;
  @media screen and (max-width: 480px) {
    background-color: #f4f4f4;
  }
`;

export const BackgroundWrapper = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  background-image: url("https://cms.vodafone.com.tr/static/img/content/23-03/02/vdf-logo.svg");
  background-position-y: 50%;
  background-size: contain;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 40px 5%;

  flex-direction: column;
  background-color: #f4f4f4;
  flex-direction: column;
  @media screen and (max-width: 480px) {
    background-color: #f4f4f4;
    margin-top: 20px;
    padding: 5%;
    background-image: url("https://cms.vodafone.com.tr/static/img/content/23-03/02/vdf-logo.svg");
    background-position-x: 50%;
    background-position: 50% 5%;
    background-size: contain;
    background-repeat: no-repeat;
    background-size: cover;
  }
`;

export const NonMobileContainer = styled.div`
  @media screen and (max-width: ${theme.breakpoint.small}) {
    display: none;
    height: auto;
  }
`;

export const Header = styled.div`
  margin-top: 20px;
  padding-left: 2px;
  padding-right: 2px;
  font-weight: 400px;
  align-items: center;
  display: flex;
  flex-direction: row;
  max-width: 1200px;
  @media screen and (max-width: ${theme.breakpoint.medium}) {
    font-size: 24px;
    text-align: center;
    font-weight: 400px;
    flex-direction: column;
  }
`;

export const ContainerWrapper = styled.div`
  justify-content: center;
  max-width: 1250px;
  max-height: 650px;
  align-items: center;

  display: flex;
  flex-direction: row;
  @media screen and (max-width: 480px) {
    flex-direction: column;
    padding: 2%;
    margin: 0px;
    max-height: 1300px;
  }
`;

export const ItemContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  margin: 38px 38px 38px 38px;
  flex: 1;
  max-width: 1200px;
  flex-direction: column;
  @media screen and (max-width: 480px) {
    margin: 3px;
  }
`;

export const IconContainer = styled.div`
  margin-top: 5px;
  margin-bottom: 16px;
  width: 80px;
  height: 80px;
  @media screen and (max-width: 480px) {
    margin-bottom: 0px;
  }
`;

export const ButtonWrapper = styled.div`
  max-width: 248px;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  @media screen and (max-width: 480px) {
  }
`;

export const TitleContainer = styled.div`
  align-items: center;
  margin-top: 15px;
  text-align: center;
  @media screen and (max-width: 480px) {
    font-size: 20px;
  }
`;

export const DescriptionContainer = styled.div`
  text-align: center;
  margin-top: 15px;
  @media screen and (max-width: 480px) {
    height: 280px;
    flex-direction: column;
  }
`;

export const DescriptionContainerMobile = styled.div`
  text-align: center;
  margin-top: 15px;
  align-items: center;
  display: flex;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  overflow-y: auto;
  height: 280px;
  white-space: nowrap;
`;

export const Contents = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 300px;
`;

export const ContentItem = styled.div`
  width: 100%;
  width: 320px;
  display: flex;
  align-items: center;
  flex-direction: column;
  align-items: center;
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 2;
  align-items: center;
`;

export const DetailItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 12px 0;
`;
